import { EMPTY_GUID, usePartyQuery } from "Api/Queries/Party/usePartyQuery";
import { usePartiesQueries } from "Api/Queries/Party/usePartiesQueries";
import type { ContactSource } from "Components/Shared/Merchant/Facilities/constants";
import type { PartyDto } from "Infrastructure/Api/Api";
import { RelationType } from "Infrastructure/Api/Api";
import { isPhoneEmpty } from "Utils/PhoneUtils";

const toContactSource = ({
  firstName,
  lastName,
  phone,
  email,
}: PartyDto): ContactSource | null => {
  const responsiblePerson = [firstName, lastName].filter(Boolean).join(" ");
  if (!responsiblePerson && isPhoneEmpty(phone) && !email) {
    return null;
  }
  return { responsiblePerson, phone, email };
};

export const useContactSources = (
  partyPublicID?: string | null,
): Array<ContactSource> => {
  const { data: partyData } = usePartyQuery(partyPublicID);

  const contactPersonIDs =
    partyData?.relatedParties
      .filter(({ relationType }) => relationType === RelationType.ContactPerson)
      .map(({ relatedPartyPublicID }) => relatedPartyPublicID)
      .filter((id) => !!id && id !== EMPTY_GUID) ?? [];

  const { data: contactPersonsParties } = usePartiesQueries(contactPersonIDs);

  if (!partyData) {
    return [];
  }

  return [partyData, ...contactPersonsParties]
    .map(toContactSource)
    .filter((source) => !!source);
};
